import { useConfigurationSections } from '../../../hooks/useConfiguration';
import { VERTICAL_CAROUSEL_IMAGE_TYPE_PATTERNS } from '../constants';
import { ImageConfig, PromotionImageObject, PromotionItem, TransformImageObject } from '../types/VerticalBlock.types';

export const useImageConfig = (): ImageConfig => {
    const { autoTrailerCarousel } = useConfigurationSections();

    return {
        portrait: {
            width: Number(autoTrailerCarousel?.long_portait_image_width) || 396,
            height: Number(autoTrailerCarousel?.long_portait_image_height) || 586,
            quality: Number(autoTrailerCarousel?.long_portait_image_quality) || 100,
        },
        landscape: {
            width: Number(autoTrailerCarousel?.landscape_image_width) || 750,
            height: Number(autoTrailerCarousel?.landscape_image_height) || 400,
        },
    };
};

export const getTrailerUrl = (item: PromotionItem): string | null => {
    return item.media ? item?.media?.releases[0]?.plrelease$url : item?.liveStream?.tuningURLs?.liveURL ?? null;
};

export const getImages = (images: PromotionImageObject[]): TransformImageObject => {
    const imageMap: TransformImageObject = {
        titleLogo: '',
        portrait: '',
        landscape: '',
    };

    images.forEach((image) => {
        Object.entries(VERTICAL_CAROUSEL_IMAGE_TYPE_PATTERNS).forEach(([key, pattern]) => {
            if (image?.url?.includes(pattern)) {
                imageMap[key as keyof TransformImageObject] = image.url || '';
            }
        });
    });

    return imageMap;
};

export const getTitle = (item: PromotionItem, lang: string): string => {
    return item?.programTitle?.[lang] || item?.title || item?.text || '';
};
